module.exports = __webpack_public_path__ + "static/hospital_support_top_img@2x-3329cd6f3f5686112d9f565c3032d8c7.png";